const CoursePageLoader = ({ message = "Loading course..." }) => {
  return (
    <div className="min-h-[60vh] w-full bg-white flex flex-col items-center justify-center gap-4 px-4 text-center">
      <div className="h-12 w-12 rounded-full border-4 border-[#F8D210]/30 border-t-[#F8D210] animate-spin" />
      <p className="font-poppins text-[14px] leading-[24px] text-[#626262]">
        {message}
      </p>
    </div>
  );
};

export default CoursePageLoader;
